export enum TranslationsEnum {
  // tłumaczenia aplikacji / api
  BadRequest = 'onarte.core.errors.400.message',
  LoginRequired = 'onarte.core.errors.401.message',
  AccessDenied = 'onarte.core.errors.403.message',
  NotFound = 'onarte.core.errors.404.message',
  Conflict = 'onarte.core.errors.409.message',
  InternalError = 'onarte.core.errors.internalError.message',
  UndefinedTranslation = 'onarte.core.errors.undefinedTranslation',
  UndefinedHostHeader = 'onarte.core.errors.undefinedHostHeader',
  UndefinedIP = 'onarte.core.errors.undefinedIP',
  NotAuthorizedHost = 'onarte.core.errors.notAuthorizedHost',
  WrongConfirmEmailToken = 'onarte.core.errors.wrongConfirmEmailToken',
  WrongResetPasswordToken = 'onarte.core.errors.wrongResetPasswordToken',
  WrongUserHash = 'onarte.core.errors.wrongUserHash',
  NonUniqueEmail = 'onarte.core.errors.nonUniqueEmail',
  NonUniquePhone = 'onarte.core.errors.nonUniquePhone',
  ManufacturerNotAssigned = 'onarte.core.errors.manufacturerNotAssigned',
  ManufacturerHasPublicProfile = 'onarte.core.errors.manufacturerHasPublicProfile',
  ManufacturerHasItems = 'onarte.core.errors.manufacturerHasItems',
  MissingContextToken = 'onarte.core.errors.missingContextToken',
  WrongManufacturerId = 'onarte.core.errors.wrongManufacturerId',
  WrongLocationId = 'onarte.core.errors.wrongLocationId',
  WrongOwnerId = 'onarte.core.errors.wrongOwnerId',
  WrongCategoryId = 'onarte.core.errors.wrongCategoryId',
  WrongItemId = 'onarte.core.errors.wrongItemId',
  WrongAttachmentId = 'onarte.core.errors.wrongAttachmentId',
  WrongAttachmentType = 'onarte.core.errors.wrongAttachmentType',
  WrongReactionType = 'onarte.core.errors.wrongReactionType',
  ReactionAlreadyExists = 'onarte.core.errors.reactionAlreadyExists',
  WrongUserId = 'onarte.core.errors.wrongUserId',
  WrongPublicProfileId = 'onarte.core.errors.wrongPublicProfileId',
  PublicProfileUnverified = 'onarte.core.errors.publicProfileUnverified',
  UndefinedPublicProfileRelation = 'onarte.core.errors.undefinedPublicProfileRelation',
  NonUniqueAttachmentPath = 'onarte.core.errors.nonUniqueAttachmentPath',
  WrongItemVersionId = 'onarte.core.errors.wrongItemVersionId',
  WrongItemVersionStatus = 'onarte.core.errors.wrongItemVersionStatus',
  WrongAttachmentPath = 'onarte.core.errors.wrongAttachmentPath',
  AuctionAlreadyExists = 'onarte.core.errors.auctionAlreadyExists',
  AuctionIsNotActive = 'onarte.core.errors.auctionIsNotActive',
  AuctionReadOnly = 'onarte.core.errors.auctionReadOnly',
  ConflictInHighLightedState = 'onarte.core.errors.conflictInHighLightedState',
  WrongAuctionId = 'onarte.core.errors.wrongAuctionId',
  WrongAuctionType = 'onarte.core.errors.wrongAuctionType',
  InvalidAuctionPrice = 'onarte.core.errors.invalidAuctionPrice',
  WrongPromotionId = 'onarte.core.errors.wrongPromotionId',
  WrongPromotionCode = 'onarte.core.errors.wrongPromotionCode',
  WrongAddressType = 'onarte.core.errors.wrongAddressType',
  CartNotEditable = 'onarte.core.errors.cartNotEditable',
  CartNotFound = 'onarte.core.errors.cartNotFound',
  CartAuctionsNotModifiable = 'onarte.core.errors.cartAuctionsNotModifiable',
  ItemWithoutDelivery = 'onarte.core.errors.itemWithoutDelivery',
  ItemHasNotCuratorialCommentary = 'onarte.core.errors.itemHasNotCuratorialCommentary',
  ItemAlreadyAssigned = 'onarte.core.errors.itemAlreadyAssigned',
  ItemNotAssigned = 'onarte.core.errors.itemNotAssigned',
  ItemIsSold = 'onarte.core.errors.itemIsSold',
  InvalidPaymentId = 'onarte.core.errors.invalidPaymentId',
  ConflictedItemExchangeToken = 'onarte.core.errors.conflictedItemExchangeToken',
  InvalidItemExchangeToken = 'onarte.core.errors.invalidItemExchangeToken',
  InvalidCartAuctionId = 'onarte.core.errors.invalidCartAuctionId',
  AuctionOfferIsAlreadyAcceptedOrRejected = 'onarte.core.errors.auctionOfferIsAlreadyAcceptedOrRejected',
  AuctionOffersIsLowerThanStartPrice = 'onarte.core.errors.auctionOffersIsLowerThanStartPrice',
  AuctionOffersIsLowerThanMaxOffer = 'onarte.core.errors.auctionOffersIsLowerThanMaxOffer',
  AuctionOffersIsNotInStepPrice = 'onarte.core.errors.auctionOffersIsNotInStepPrice',
  AuctionOffersPriceIsNotPositiveInteger = 'onarte.core.errors.auctionOffersPriceIsNotPositiveInteger',
  NewsletterSubscriberAlreadyExist = 'onarte.core.errors.newsletterSubscriberAlreadyExist',
  AgreementRequiredNotSelected = 'onarte.core.errors.agreementRequiredNotSelected',
  AuthDataIsIncorrect = 'onarte.core.errors.authDataIsIncorrect',
  AccountIsNotActivated = 'onarte.core.errors.accountIsNotActivated',
  CollectionIsNotActive = 'onarte.core.errors.collectionIsNotActive',
  DpdError = 'onarte.core.errors.dpdExternalError',
  StorageError = 'onarte.core.errors.storageError',
  SliderIsNotActive = 'onarte.core.errors.sliderIsNotActive',
  PaymentGatewayNotFound = 'onarte.core.errors.paymentGatewayNotFound',
  PaymentGatewayIsNotAvailable = 'onarte.core.errors.paymentGatewayIsNotAvailable',
  SellersDataNotFound = 'onarte.core.errors.sellersDataNotFound',
  RecommendationSliderAlreadyExists = 'onarte.core.errors.recommendationSliderAlreadyExists',
  // tłumaczenia e-mail
  EmailRegistrationTitle = 'onarte.emails.registration.title',
  EmailResetPasswordTitle = 'onarte.emails.resetPassword.title',
  EmailPaymentRequiredTitle = 'onarte.emails.paymentRequired.title',
  EmailCustomerOrderConfirmationTitle = 'onarte.emails.customerOrderConfirmation.title',
  EmailSellerOrderConfirmationTitle = 'onarte.emails.sellerOrderConfirmation.title',
  EmailCustomerBiddingWonTitle = 'onarte.emails.customerBiddingWon.title',
  EmailCustomerBiddingLostTitle = 'onarte.emails.customerBiddingLost.title',
  EmailCustomerOutbidTitle = 'onarte.emails.customerOutbid.title',
  EmailSellerNewBidTitle = 'onarte.emails.sellerNewBid.title',
  EmailCustomerHighestBidTitle = 'onarte.emails.customerHighestBid.title',
  EmailSellerBiddingSoldTitle = 'onarte.emails.sellerBiddingSold.title',
  EmailCustomerDeliveryStatusTitle = 'onarte.emails.customerDeliveryStatus.title',
  EmailVerificationArtworkApprovedTitle = 'onarte.emails.verificationArtworkApproved.title',
  EmailVerificationArtworkRejectedTitle = 'onarte.emails.verificationArtworkRejected.title',
  EmailSellerArtworkNotSoldTitle = 'onarte.emails.sellerArtworkNotSold.title',
  EmailCustomerBuyOfferTitle = 'onarte.emails.customerBuyOffer.title',
  EmailCustomerOfferAcceptedTitle = 'onarte.emails.customerOfferAccepted.title',
  EmailCustomerOfferCanceledTitle = 'onarte.emails.customerOfferCanceled.title',
  EmailCustomerOfferRejectedTitle = 'onarte.emails.customerOfferRejected.title',
  EmailSellerBuyOfferTitle = 'onarte.emails.sellerBuyOffer.title',
  EmailSellerOfferAcceptedTitle = 'onarte.emails.sellerOfferAccepted.title',
  EmailSellerOfferCanceledTitle = 'onarte.emails.sellerOfferCanceled.title',
  EmailSellerOfferRejectedTitle = 'onarte.emails.sellerOfferRejected.title',
  EmailSellerCourierConfirmationTitle = 'onarte.emails.sellerCourierConfirmation.title',
  EmailVerificationPublicProfileTitle = 'onarte.emails.verificationPublicProfile.title',
  // walidacja
  ValidationErrorForm = 'onarte.validation.error.form',
  ValidationErrorIsNotEmpty = 'onarte.validation.error.isNotEmpty',
  ValidationErrorItemNotFound = 'onarte.validation.error.itemNotFound',
  /** Pass {{max}} in context */
  ValidationErrorMaxLength = 'onarte.validation.error.maxLength',
  ValidationErrorCoverNotFound = 'onarte.validation.error.coverNotFound',
  ValidationErrorCoverInvalidType = 'onarte.validation.error.coverInvalidType',
  /** Pass {{min}} in context */
  ValidationErrorMin = 'onarte.validation.error.min',
  /** Pass {{max}} in context */
  ValidationErrorMax = 'onarte.validation.error.max',
  ValidationErrorIsBoolean = 'onarte.validation.error.isBoolean',
  ValidationErrorStartTimeCannotBeGreaterEndTime = 'onarte.validation.error.startTimeCannotBeGreaterEndTime',
  ValidationErrorCannotChangeTimeAfterStart = 'onarte.validation.error.cannotChangeTimeAfterStart',
  ValidationErrorNotFound = 'onarte.validation.error.notFound',
  ValidationErrorBlogPostNotFound = 'onarte.validation.error.blogPostNotFound',
}
